import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getCities } from 'models/cities'; // Importing getCities function from cities model
import { getTags } from 'models/tags'; // Importing getTags function from tags model
import { getPositions } from 'models/positions'; // Importing getPositions function from positions model
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix
import {
    profile, // User profile information
    devConfig, // Development configuration settings
    countries, // List of countries
    paymentSystem, // Payment system configurations
    cashDesks, // Cash desk configurations
    agentList, // List of agents
} from 'config/config'; // Importing configuration settings

/**
 * Class representing the FilterAgentListView.
 * @extends JetView
 */
export default class FilterAgentListView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            // Left section of the filter form
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    hidden: devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                    css: 'prm-filterByUser',
                    height: 1,
                },
                {
                    view: 'text', // Text input for User ID
                    name: 'Id',
                    type: 'number',
                    label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'),
                    hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                    css: 'prm-filterByUser',
                    labelPosition: 'top',
                    placeholder: _('ID Usuario'),
                },
            ],
        };

        const center_left = {
            // Center-left section of the filter form
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    hidden: devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                    css: 'prm-filterByUser',
                    height: 1,
                },
                {
                    view: 'text', // Text input for User Login
                    name: 'Login',
                    label: "<span class='icon-mail'></span>" + _('Usuario (Correo electrónico)'),
                    labelPosition: 'top',
                    placeholder: _('Usuario (Correo electrónico)'),
                    hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                    css: 'prm-filterByUser',
                },
            ],
        };

        const center_right = {
            // Center-right section of the filter form
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    hidden: devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                    css: 'prm-filterByUser',
                    height: 1,
                },
                {
                    view: 'text', // Text input for User Name
                    name: 'Name',
                    label: "<span class='icon-user'></span>" + _('Nombre'),
                    labelPosition: 'top',
                    placeholder: _('Nombre'),
                    hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                    css: 'prm-filterByUser',
                },
            ],
        };

        const right = {
            // Right section of the filter form
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect', // Dropdown for selecting Partner
                    name: 'Partner',
                    label: _('Partner'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    value: profile.PartnerSelected, // Default selected value
                    options: profile.Partners, // Options for the dropdown
                    hidden: !profile.Partners.length > 2, // Conditional visibility based on number of partners
                },
            ],
        };

        const upper_section = {
            // Upper section containing the filter inputs
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right, right], // Layout of the filter inputs
                },
            ],
        };

        const buttons = {
            // Button section for the filter form
            margin: 5,
            cols: [
                {},
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        // Clear action
                        this.getRoot().clear();
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'),
                    hotkey: 'enter', // Hotkey for the button
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        // Consult action
                        const filterdata = this.getRoot().getValues(); // Get filter values
                        this.app.callEvent('playersList:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };

        return {
            // Return the complete form configuration
            view: 'form',
            rows: [upper_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
}

// FILE DOCUMENTED
